let appId = {
    "production": 'com.acme-ai.elite-manage-pilot',
    "testing": 'com.acme-ai.elite-manage-pilot-test',
};

module.exports = {
    APPID: appId,
    // 正式包
    production: {
        electronBuilder: {
            builderOptions: {
                'appId': appId['production'],
                "win": {
                    "requestedExecutionLevel": "highestAvailable",
                    "icon": './logo.png',
                    "extraFiles": []
                },
                "mac": {
                    "icon": './logo.png',
                    "extraFiles": []
                },
                'productName': 'ACME ManagePilot', // 包名称
                'nsis': {
                    "perMachine": false,
                    "oneClick": true,
                    "allowToChangeInstallationDirectory": false,
                    "shortcutName": 'ACME ManagePilot' // 快捷方式名称
                },
            }
        }
    },
    testing: {
        electronBuilder: {
            builderOptions: {
                'appId': appId['testing'],
                "win": {
                    "requestedExecutionLevel": "highestAvailable",
                    "icon": './logo.png',
                    "extraFiles": []
                },
                "mac": {
                    "icon": './logo.png',
                    "extraFiles": []
                },
                'productName': 'ACME ManagePilot Test', // 包名称
                'nsis': {
                    "perMachine": false,
                    "oneClick": true,
                    "allowToChangeInstallationDirectory": false,
                    "shortcutName": 'ACME ManagePilot Test' // 快捷方式名称
                },
            }
        }
    }
}
